export const VIDEO_CONSTRAINTS = {
  width: 1280,
  height: 720,
  facingMode: 'user',
};
